import BillingStudentDashboard from './install';

global.dashboard = BillingStudentDashboard;

// TODO: documentar o uso do plugin
export default BillingStudentDashboard;
